import { Link, styled } from '@mui/material';
import { gridClasses } from '@mui/x-data-grid-pro';

export const Root = styled(Link)({
  display: 'flex',
  alignItems: 'center',
  flex: '0 0 auto',
  overflow: 'hidden',
}) as typeof Link;

export const StartIcon = styled('span')(({ theme }) => ({
  width: 0,
  transition: theme.transitions.create(['width', 'opacity']),
  opacity: 0,
  display: 'inherit',
  [`.${gridClasses.row}:hover &`]: {
    display: 'inherit',
    opacity: 1,
    width: 26,
  },
}));
